import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { requireResourcesFeature } from '@/features/resources/guard';
import { ResourceUserList } from '@/features/resources/people/resource-user-list';

export const Route = createFileRoute('/_app/admin/resources/')({
  beforeLoad: async ({ context }) => {
    requirePermission(context.me, 'job_roles.manage');
    await requireResourcesFeature(context.queryClient);
  },
  component: ResourceUserList,
});
